/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DimensionListRequest {
    getFixupPrototypeFunction() { return DimensionListRequest.fixupPrototype; }

    static newInstance(model: Partial<DimensionListRequest>): DimensionListRequest {
        let obj = Object.assign(new DimensionListRequest(), model);
        DimensionListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DimensionListRequest>): DimensionListRequest {
        if (!model) return null;
        return DimensionListRequest.newInstance(<DimensionListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DimensionListRequest) {
        if (!obj) return;

        models.DimensionListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DimensionListRequest): boolean {
        Object.setPrototypeOf(obj, DimensionListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.DimensionDefinitionFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.DimensionSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.DimensionSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.DimensionDefinitionFilter;

}
